import { DragObjectWithType } from "react-dnd";
import { Color, Shape } from "../../api/models";

export enum DragObjectTypes {
    Tile = "Tile"
}

export interface TileDragObject extends DragObjectWithType {
    id: number
    color: Color
    shape: Shape
}